import React, { useState, useRef, useEffect } from 'react';
import { AD_ATTRIBUTES } from '../../utils/adAttributes';
import './ShortcodeSelector.css';

function ShortcodeSelector({ onSelect, inputRef }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Calculer la position du dropdown
  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = 380;
      const viewportWidth = window.innerWidth;

      // Position verticale : en dessous du bouton
      const top = buttonRect.bottom + 8;

      // Position horizontale : essayer d'aligner à droite du bouton
      let left = buttonRect.right - dropdownWidth;

      // Si le dropdown sort à gauche de la fenêtre, l'aligner à gauche du bouton
      if (left < 20) {
        left = buttonRect.left;
      }

      // Si le dropdown sort à droite, le décaler
      if (left + dropdownWidth > viewportWidth - 20) {
        left = viewportWidth - dropdownWidth - 20;
      }

      setDropdownPosition({ top, left });
    }
  }, [isOpen]);

  // Fermer le dropdown au clic externe
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (shortcode) => {
    onSelect(shortcode);
    setIsOpen(false);
    setSearchTerm('');
  };

  // Filtrer les attributs selon la recherche
  const filteredCategories = AD_ATTRIBUTES.map(category => ({
    ...category,
    attributes: category.attributes.filter(attr =>
      attr.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
      attr.shortcode.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.attributes.length > 0);

  return (
    <div className="shortcode-selector">
      <button
        ref={buttonRef}
        type="button"
        className="shortcode-btn"
        onClick={() => setIsOpen(!isOpen)}
        title="Insérer un champ Active Directory"
      >
        <span className="shortcode-icon">{'{ }'}</span>
        <span className="shortcode-text">Champ AD</span>
      </button>

      {isOpen && (
        <div
          ref={dropdownRef}
          className="shortcode-dropdown"
          style={{
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`
          }}
        >
          <div className="shortcode-search">
            <input
              type="text"
              placeholder="Rechercher un champ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>

          <div className="shortcode-list">
            {filteredCategories.length === 0 ? (
              <div className="shortcode-empty">Aucun champ trouvé</div>
            ) : (
              filteredCategories.map((category, idx) => (
                <div key={idx} className="shortcode-category">
                  <div className="shortcode-category-title">{category.category}</div>
                  {category.attributes.map((attr, attrIdx) => (
                    <div
                      key={attrIdx}
                      className="shortcode-item"
                      onClick={() => handleSelect(attr.shortcode)}
                    >
                      <div className="shortcode-item-main">
                        <span className="shortcode-item-label">{attr.label}</span>
                        <span className="shortcode-item-code">{attr.shortcode}</span>
                      </div>
                      <div className="shortcode-item-example">
                        Ex: {attr.example}
                      </div>
                    </div>
                  ))}
                </div>
              ))
            )}
          </div>

          <div className="shortcode-footer">
            <small>Cliquez pour insérer • Les données seront remplacées depuis l'AD</small>
          </div>
        </div>
      )}
    </div>
  );
}

export default ShortcodeSelector;
